<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/role' }">职位管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}职位</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form-group">
      <div class="form myform">
        <div class="formtitle">基本信息</div>
        <el-form ref="form" :model="form" label-width="150px" label-position="left">
          <el-form-item label="职位名称：" prop="role_name">
            <el-col :span="20">
              <el-input placeholder="请输入职位名称" maxlength="50" v-model="form.role_name" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="部门：" prop="department">
            <el-col :span="20">
              <el-select v-model="form.dep_id" placeholder="请选择" style="width: 100%;" clearable filterable>
                <el-option :label="`${v.en_name}`" :value="v.id" v-for="(v, i) in departList" :key="i"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="备注：" prop="mark">
            <el-col :span="20">
              <el-input placeholder="请输入职位备注或说明" type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
                v-model="form.mark" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="职位用户列表：" prop="user">
            <div class="form-user">
              <div class="user-table" v-if="Object.keys(user).length">
                <div v-for="(v, i) in user" :key="`use_${i}`">
                  <div>{{ v.realname }} {{ v.en_name }}</div>
                  <div class="dtbtn" @click="toAuthor(v)">重新分配职位</div>
                </div>
              </div>
              <div v-else>暂无</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="form myform">
        <div class="formtitle">页面权限</div>
        <div class="menutable">
          <div class="menuline" v-for="(v, i) in menuList" :key="`menu_${i}`">
            <div class="table-label">
              <div class="tlabel">
                <el-checkbox :value="menuForm[v.unique_auth]" :indeterminate="v.isIndeterminate"
                  @change="(e) => updateMenu(i, v.id, v.unique_auth, e, 1)" :disabled="v.unique_auth == 'index' || v.unique_auth == 'staff' ">{{ v.node_name }}</el-checkbox>
              </div>
            </div>
            <div class="table-items">
              <div class="item" v-for="(val, idx) in v.children" :key="`menu_item_${idx}`">
                <div class="item-self">
                  <el-checkbox :value="menuForm[val.unique_auth]" @change="(e) => updateMenu(i, val.id, val.unique_auth, e, 2)
                    " :disabled="val.unique_auth == 'index_list' || val.unique_auth == 'staff_reim' || val.unique_auth == 'staff_holiday_overview' || val.unique_auth == 'staff_holiday'">{{ val.node_name }}</el-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form myform">
        <div class="formtitle">操作权限</div>
        <div class="nodetable">
          <div class="nodeline" v-for="(v, i) in nodeList" :key="`node_${i}`"
            :class="`${v.show_sort ? 'show_sort' : ''} ${v.show_sort_tail ? 'show_sort_tail' : ''}`">
            <div class="nodetitle" v-if="v.show_sort">{{ v.show_level == '1' ? '首页' : v.show_level == '2' ? '客户项目' :
              (v.show_level == '3' ? '行政采购' : (v.show_level == '4' ? '人力资源' : (v.show_level == '5' ? '个人事务' :
                (v.show_level == '6' ? '客户/供应商管理' : (v.show_level == '7' ? '账号管理' : '其他管理'))))) }}</div>
            <div class="nodecon">
              <div class="table-label" v-if="v.isShowOn">
                <div class="tlabel node-label">
                  <div class="tlabel_word">{{ v.node_name }}</div>
                </div>
              </div>
              <div class="table-items" v-if="v.isShowOn">
                <div class="item node-item" v-for="(val, idx) in v.node" :key="`node_item_${idx}`">
                  <div class="item-self">
                    <el-checkbox :value="nodeForm[val.unique_auth]" :indeterminate="val.isIndeterminate"
                      @change="(e) => updateNode(i, idx, '', val.unique_auth, e, 2, val.id)"
                      v-if="val.node_name != 'group'">{{ val.node_name }}</el-checkbox>
                  </div>
                  <div class="item-ul">
                    <div class="item-li" v-for="(value, index) in val?.children" :key="`item_li_${index}`">
                      <el-checkbox :value="nodeForm[value.unique_auth]" @change="(e) =>
                        updateNode(i, idx, index, value.unique_auth, e, 3, value.id)">{{ value.node_name
                        }}</el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="formbtn" style="margin-top: 20px">
          <el-button @click="resetForm('form')">取消</el-button>
          <el-button type="primary" @click="submitForm('form')">确定</el-button>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import * as api from "@/api";
export default {
  name: "roleDetail",
  data() {
    return {
      nodeLimtList: [],
      departList: [],
      optionType: "1",
      user: {},
      form: {
        option: "1",
        id: "",
        role_name: "",
        mark: "",
      },
      menuList: [],
      menuForm: {
        index: true,
        index_list: true,
        staff: true,
        staff_reim: true,
        staff_holiday_overview: true,
        staff_holiday: true,
      },
      menu_id: "250, 17", //1和16作为父级id不传
      menu_id_list: ["250", "17"],
      nodeList: [],
      nodeForm: {},
      node_id: "",
      node_id_list: [],
      menu_expt_list: ["1", "2", "8", "12", "16", "19", "22", "25"],
      menu_del_list: [],
    };
  },
  created() {
    this.query.id && this.getDetail(this.query.id);
    this.optionType = this.query.type ? this.query.type : "1";
  },
  mounted() {
    this.getDepartList();
    this.getMenuNodeList();
    this.getNodeList();
  },
  watch: {},
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分
      const hash = window.location.hash;
      // 移除'#'字符
      const url = hash.substring(1);
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      };
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(",");
      });
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val);
    },
    async getDepartList() {
      return new Promise((resolve) => {
        this.$fly
          .post('apiAccount_getDepartmentList.html', {

          })
          .then((res) => {
            this.departList = res
            resolve(res)
          })
      })
    },
    getDetail(id) {
      this.checkUrlFn();
      const that = this;
      that.$fly
        .post("ApiRole_roleInfo.html", {
          role_id: id,
        })
        .then((res) => {
          const { role_name, mark, menu_ids, menu_arr, node_arr, user, dep_id } = res;
          that.user = user;
          that.form = {
            id,
            option: "1",
            role_name: this.optionType == "1" ? role_name : "",
            mark: this.optionType == "1" ? mark : "",
            dep_id,
          };
          if (menu_ids) {
            that.menu_id = menu_ids;
            that.menu_id_list = that.menu_id
              .split(",")
              .filter((item) => !that.menu_expt_list.includes(item));
            that.menu_id = that.menu_id_list.join(",");
            that.menuForm = menu_arr;
            that.nodeForm = node_arr;
            that.getNodeList(this.menu_id);
          }
        });
    },
    getMenuNodeList() {
      api.getMenuNodeList({}).then((res) => {
        const that = this;
        that.menuList = res.map((item) => {
          item.isShowOn = true;
          for (let i = 0; i < item.children.length; i++) {
            let _child = item.children[i];
            if (_child.unique_auth in that.menuForm) {
              _child.isCheck = true;
            } else {
              _child.isCheck = false;
            }
          }
          that.$forceUpdate();
          let list_count = 0;
          for (let j = 0; j < item.children.length; j++) {
            const _child = item.children[j];
            if (_child.isCheck == true) {
              list_count++;
            }
          }
          if (list_count < item.children.length && list_count > 0) {
            item.isCheck = false
            item.isIndeterminate = true;
          } else if (list_count == item.children.length) {
            item.isCheck = true;
            item.isIndeterminate = false;
          } else if (list_count == 0) {
            item.isCheck = false;
            item.isIndeterminate = false;
          }
          that.$forceUpdate();
          return item;
        });
      });
    },
    getNodeList(id) {
      api
        .getNodeList({
          id,
        })
        .then((res) => {
          const that = this;
          that.nodeList = res.map((item) => {
            item.isShowOn = true;
            for (let i = 0; i < item.node.length; i++) {
              let _node = item.node[i];
              if (_node.unique_auth in that.nodeForm) {
                _node.isCheck = true;
              } else {
                _node.isCheck = false;
                that.nodeForm[_node.unique_auth] = false; //给定初始值
              }
              // that.checkMatch(_node.id)
              that.$forceUpdate();
              for (let j = 0; j < _node.children.length; j++) {
                let _children = _node.children[j];
                if (_children.unique_auth in that.nodeForm) {
                  _children.isCheck = true;
                } else {
                  _children.isCheck = false;
                  that.nodeForm[_children.unique_auth] = false; //给定初始值
                }
                // that.checkMatch(_children.id)
                that.$forceUpdate();
              }
            }
            for (let j = 0; j < item.node.length; j++) {
              let _node = item.node[j];
              //计算最子级的选中项，决定是否半选
              let node_count = 0;
              for (let k = 0; k < _node.children.length; k++) {
                const _child = _node.children[k];
                if (_child.isCheck) {
                  node_count++;
                }
              }
              if (
                node_count != _node.children.length &&
                node_count != 0 &&
                _node.isCheck == false
              ) {
                _node.isIndeterminate = true;
              } else {
                _node.isIndeterminate = false;
              }
            }
            return item;
          });
          console.log(that.nodeList);
          that.checkFirstAdd(that.nodeList, "show_level", "show_sort", "isShow");
          that.checkLastAdd(that.nodeList, "show_level", "show_sort_tail", "isShow");
        });
    },
    getChildNodeList(id) {
      api
        .getChildNodeList({
          node_id: id,
        })
        .then((res) => {
          this.childNodeList = res;
        });
    },
    updateMenu(index, id, key, value, type) {
      const that = this;
      that.menuForm[key] = value;
      that.$forceUpdate();
      if (type == 1) {
        //选父级
        if (value) {
          //全选
          //不传父级id
          const $unique_auth = that.menuList[index].unique_auth;
          that.menuForm[$unique_auth] = true;
          that.menuList[index].isCheck = true;
          that.menuList[index].isIndeterminate = false;
          const children = that.menuList[index].children;
          for (let i = 0; i < children?.length; i++) {
            let child = children[i];
            that.menu_id_list = that.menu_id_list.concat(child.id);
            that.menuForm[child.unique_auth] = true;
            child.isCheck = true;
            that.$forceUpdate();
          }
        } else {
          //全不选
          const $unique_auth = that.menuList[index].unique_auth;
          that.menuForm[$unique_auth] = false;
          that.menuList[index].isCheck = false;
          that.menuList[index].isIndeterminate = false;
          that.menu_id_list = that.menu_id_list.filter((item) => item !== id);
          const children = that.menuList[index].children;
          for (let i = 0; i < children?.length; i++) {
            let child = children[i];
            that.menu_id_list = that.menu_id_list.filter((item) => item !== child.id);
            that.menuForm[child.unique_auth] = false;
            child.isCheck = false;
            that.$forceUpdate();
          }
          that.delMenuFn(id);
        }
      } else {
        //选子级
        if (value) {
          that.menu_id_list = that.menu_id_list.concat(id);
          const children = that.menuList[index].children;
          for (let i = 0; i < children?.length; i++) {
            let child = children[i];
            if (child.id == id) {
              that.menuForm[child.unique_auth] = true;
              child.isCheck = true;
              that.$forceUpdate();
            }
          }
        } else {
          that.menu_id_list = that.menu_id_list.filter((item) => item !== id);
          const children = that.menuList[index].children;
          for (let i = 0; i < children?.length; i++) {
            let child = children[i];
            if (child.id === id) {
              that.menuForm[child.unique_auth] = false;
              child.isCheck = false;
              that.$forceUpdate();
              that.delMenuFn(id);
            }
          }
        }
        let count = 0;
        const menu_children = that.menuList[index].children;
        for (let i = 0; i < menu_children.length; i++) {
          const element = menu_children[i];
          if (element.isCheck) count++;
        }
        // 如果true true 或者 false true样式为-;
        // true false样式为√;
        // 如果false false样式为不勾;
        const $unique_auth = that.menuList[index].unique_auth;
        if (count === 0) {
          that.menuList[index].isCheck = false;
          that.menuForm[$unique_auth] = false;
          that.menuList[index].isIndeterminate = false;
        } else if (count === menu_children.length) {
          that.menuList[index].isCheck = true;
          that.menuForm[$unique_auth] = true;
          that.menuList[index].isIndeterminate = false;
        } else if (count !== 0 && count !== menu_children.length) {
          that.menuList[index].isCheck = false;
          that.menuForm[$unique_auth] = false;
          that.menuList[index].isIndeterminate = true;
        }
      }
      that.menu_id = that.menu_id_list.join(",");
      that.getNodeList(that.menu_id);
    },
    updateNode(index, childIndex, grandsonIndex, key, value, type, id) {
      const that = this;
      that.nodeForm[key] = value;
      that.$forceUpdate(); //非常重要，不然会报错
      if (type == 1) {
        //选父级
        //已注释
        return false;
      } else if (type == 2) {
        //选次子级
        if (value) {
          //全选
          that.nodeList[index].node[childIndex].isCheck = true;
          that.nodeList[index].node[childIndex].isIndeterminate = false;
          const $nodeChild = that.nodeList[index].node[childIndex].children;
          if ($nodeChild.length) {
            for (let i = 0; i < $nodeChild.length; i++) {
              let nodeItem = $nodeChild[i];
              nodeItem.isCheck = true;
              that.nodeForm[nodeItem.unique_auth] = true;
              that.$forceUpdate();
            }
          }
        } else {
          that.nodeList[index].node[childIndex].isCheck = false;
          that.nodeList[index].node[childIndex].isIndeterminate = false;
          const $nodeChild = that.nodeList[index].node[childIndex].children;
          if ($nodeChild) {
            for (let i = 0; i < $nodeChild.length; i++) {
              let nodeItem = $nodeChild[i];
              nodeItem.isCheck = false;
              that.nodeForm[nodeItem.unique_auth] = false;
              that.$forceUpdate();
            }
          }
        }
        that.checkMatch(id);
      } else if (type == 3) {
        //选子级
        let $children = that.nodeList[index].node[childIndex];
        if (value) {
          $children.children[grandsonIndex].isCheck = true;
        } else {
          $children.children[grandsonIndex].isCheck = false;
        }
        //向上检测一级
        let count = 0;
        const $first = that.nodeList[index].node[childIndex].children;
        for (let i = 0; i < $first.length; i++) {
          const element = $first[i];
          if (element.isCheck) count++;
        }
        // 如果true true 或者 false true样式为-;
        // true false样式为√;
        // 如果false false样式为不勾;
        const $unique_auth = that.nodeList[index].node[childIndex].unique_auth;
        if (count === 0) {
          //不勾
          that.nodeList[index].node[childIndex].isCheck = false;
          that.nodeForm[$unique_auth] = false;
          that.nodeList[index].node[childIndex].isIndeterminate = false;
        } else if (count === $first.length) {
          //勾
          that.nodeList[index].node[childIndex].isCheck = true;
          that.nodeForm[$unique_auth] = true;
          that.nodeList[index].node[childIndex].isIndeterminate = false;
        } else if (count > 0 && count < $first.length) {
          //半选
          that.nodeList[index].node[childIndex].isCheck = false;
          that.nodeForm[$unique_auth] = false;
          that.nodeList[index].node[childIndex].isIndeterminate = true;
        }
        that.$forceUpdate();
        that.checkMatch(id);
      }
    },
    delMenuFn(id) {
      const that = this;
      that.$fly
        .post("ApiNode_updateUserNode.html", {
          role_id: that.form.id,
          del_id: id,
        })
        .then(() => {
          that.$fly
            .post("ApiRole_roleInfo.html", {
              role_id: that.form.id,
            })
            .then((res) => {
              const { menu_ids, node_arr } = res;
              that.nodeForm = node_arr;
              that.getNodeList(menu_ids);
            });
        });
    },
    checkMatch(form_id) {
      const that = this;
      let to_id_list = []; //存放需要删除选择的页面的id
      if (form_id == "30") {
        //查看项目详情
        to_id_list = ["63", "64", "65"];
      }
      if (form_id == "44") {
        //查看收款详情
        to_id_list = ["64",];
      }
      if (form_id == "52") {
        //查看支出详情
        to_id_list = ["65"];
      }
      if (form_id == "98") {
        //查看发票详情
        to_id_list = ["243"];
      }
      if (form_id == "126") {
        //查看行政项目详情
        to_id_list = ["70", "114"];
      }
      if (form_id == "140") {
        //查看支出详情
        to_id_list = ["114"];
      }
      if (form_id == "158") {
        //查看人力项目详情
        to_id_list = ["74", "75"];
      }
      if (form_id == "164") {
        //查看支出详情
        to_id_list = ["74"];
      }
      if (form_id == "186") {
        //查看报销详情
        to_id_list = ["79"];
      }
      if (form_id == "200") {
        //查看账号详情
        to_id_list = ["83"];
      }
      if (form_id == "383") {
        //查看账号详情
        to_id_list = ["385"];
      }
      let tempCheck = true; // 用来控制页面中显示隐藏
      for (let i = 0; i < that.nodeList.length; i++) {
        //找到指定的id，和它的isCheck
        let _list = that.nodeList[i];
        if (_list.id == form_id) {
          tempCheck = _list.isCheck;
        } else {
          for (let j = 0; j < _list.node.length; j++) {
            let _node = _list.node[j];
            if (_node.id == form_id) {
              tempCheck = _node.isCheck;
            } else {
              for (let j = 0; j < _node.children.length; j++) {
                let _child = _node.children[j];
                if (_child.id == form_id) {
                  tempCheck = _child.isCheck;
                }
              }
            }
          }
        }
      }
      if (to_id_list.length) {
        for (let a = 0; a < to_id_list.length; a++) {
          //遍历to_id_list, 匹配到的to_id都要取消选择
          const to_id = to_id_list[a];
          for (let i = 0; i < that.nodeList.length; i++) {
            let _list = that.nodeList[i];
            if (_list.id == to_id) {
              _list.isShowOn = tempCheck;
              that.$forceUpdate();
              if (!_list.isShowOn) {
                //如果不选则页面上隐藏
                _list.isCheck = false;
                _list.isIndeterminate = false;
                that.nodeForm[_list.unique_auth] = false;
                for (let j = 0; j < _list.node.length; j++) {
                  let _node = _list.node[j];
                  _node.isCheck = false;
                  that.nodeForm[_node.unique_auth] = false;
                  _node.isIndeterminate = false;
                  that.$forceUpdate();
                  for (let k = 0; k < _node.children.length; k++) {
                    let _child = _node.children[k];
                    _child.isCheck = false;
                    that.nodeForm[_child.unique_auth] = false;
                    that.$forceUpdate();
                  }
                }
              }
            }
          }
        }
      }
    },
    checkFirstAdd(array, key, newValueKey, newValue) {
      let currentValue = null;
      let isFirstInSequence = true; // 用于标记是否是当前序列的第一个元素  

      array.forEach((item) => {
        const itemValue = item[key];
        if (itemValue !== currentValue) {
          // 如果当前元素的值与前一个元素的值不同，说明进入了一个新的值序列  
          currentValue = itemValue;
          isFirstInSequence = true; // 重置为true，因为我们现在在新序列的第一个元素上  
        }

        if (isFirstInSequence) {
          // 如果是当前序列的第一个元素，则添加新属性  
          item[newValueKey] = newValue;
          isFirstInSequence = false; // 标记为已处理，避免在同一个序列中重复添加  
        }
      });

      return array;
    },
    checkLastAdd(array, key, newValueKey, newValue) {
      let currentValue = null;
      // 遍历数组，并找到每个值的最后一个元素
      array.forEach((item, index) => {
        const itemValue = item[key];
        if (itemValue !== currentValue) {
          // 如果当前元素的值与前一个元素的值不同，说明这是新值的第一个元素
          currentValue = itemValue;
        }
        // 在最后一个相同值的元素上添加新属性
        // 检查是否到达数组的末尾，或者下一个元素的值与前一个不同
        if (index === array.length - 1 || array[index + 1][key] !== itemValue) {
          item[newValueKey] = newValue;
        }
      });
      return array;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateRight();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$router.go(-1);
    },
    addUpdateRight() {
      const that = this;
      if (this.optionType == "1") {
        that.$fly
          .post("ApiRole_addOrUpdateRole.html", {
            option: "2",
            id: that.form.id,
            role_name: that.form.role_name,
            mark: that.form.mark,
            dep_id: that.form.dep_id,
          })
          .then(() => {
            that.$fly
              .post("ApiRole_modifyRoleNode.html", {
                id: that.form.id,
                option: "1",
                ...that.menuForm,
                ...that.nodeForm,
              })
              .then(() => {
                this.$message.success("success");
                this.$router.go(-1);
              });
          });
      } else {
        if (!that.form.role_name) {
          that.$message.error("请填写职位名");
          return false;
        }
        that.$fly
          .post("ApiRole_addOrUpdateRole.html", {
            option: "1",
            role_name: that.form.role_name,
            mark: that.form.mark,
          })
          .then((res) => {
            that.form.id = res.role_id;
            that.$fly
              .post("ApiRole_addOrUpdateRole.html", {
                ...that.form,
              })
              .then(() => {
                that.$fly
                  .post("ApiRole_modifyRoleNode.html", {
                    id: that.form.id,
                    option: "1",
                    ...that.menuForm,
                    ...that.nodeForm,
                  })
                  .then(() => {
                    this.$message.success("success");
                    this.$router.go(-1);
                  });
              });
          });
      }
    },
    toAuthor(item) {
      this.$router.push({
        path: "/author/build",
        query: { id: item.id, type: 1 },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .filterwrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 15px 0;

    .el-button {
      margin: 0 0 0 20px;
    }
  }

  .apage {
    background: #f2f2f2;
    padding: 8px;
    text-align: right;
  }

  .el-select {
    margin-right: 20px;
  }

  .el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
    height: 36px;
    line-height: 36px;
    border: none;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;
  }

  .table {
    @extend %box;
    padding: 30px;
  }

  .line {
    text-align: center;
  }

  .group-head {
    font-size: 18px;
    font-weight: 700;
    padding-left: 10px;
    color: #10456d;
  }
}

.formtitle {
  position: relative;
  left: -50px;
  margin-bottom: 30px;
  font-size: 28px;
  line-height: 48px;
  font-weight: 600;
}

.menutable {
  border: 1px solid #333;
  border-bottom: 0;

  .menuline {
    @extend %start;
    align-items: stretch;

    &.show_sort {
      padding-bottom: 40px;
      position: relative;

      &::after {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 40px;
        background: #333;
      }
    }

    .table-label {
      width: 200px;
      min-height: 50px;
      border-right: 1px solid #333;
      border-bottom: 1px solid #333;

      .tlabel {
        padding: 20px;

        &.node-label {
          padding: 15px;
        }

        .tlabel_word {
          font: 600 14px/19px Avenir, Helvetica, Arial, sans-serif;
          color: #0e0f22;
        }
      }
    }

    .table-items {
      @extend %start;
      flex-flow: row wrap;
      width: calc(100% - 200px);
      min-height: 50px;
      border-bottom: 1px solid #333;

      .item {
        padding: 5px;

        &.node-item {
          @extend %start;
          width: 100%;
          padding: 0;
          border-bottom: 1px solid #333;

          &:last-of-type {
            border-bottom: 0;
          }

          .item-self {
            box-sizing: border-box;
            width: 200px;
          }

          .item-ul {
            width: calc(100% - 200px);
            min-height: 49px;
            background: #fff;
            border-left: 1px solid #333;
          }
        }

        .item-self {
          width: 180px; //最小宽度
          padding: 15px;
        }

        .item-ul {
          @extend %start;
          flex-flow: row wrap;
          min-width: 180px;
          max-width: calc(210px * 5);
          // margin: 15px 0;
          background: #f1f1f1;

          .item-li {
            width: 180px; //最小宽度
            padding: 15px;
          }
        }
      }
    }
  }
}

.nodetable {

  .nodeline {
    padding: 10px 20px 20px;
    background: #ececec;
    &.show_sort {
      position: relative;
      margin-bottom: 0;
    }

    &.show_sort_tail {
      margin-bottom: 40px;
    }
    .nodetitle {
      font: 600 22px/44px Avenir, Helvetica, Arial, sans-serif;
      color: #0e0f22;
    }
    .nodecon {
      padding: 30px 20px;
      background: #fff;
      border-radius: 10px;
      @extend %center;
      align-items: stretch;

      .table-label {
        width: 200px;
        min-height: 50px;
        text-align: left;

        .tlabel {
          padding: 20px;

          &.node-label {
            padding: 15px;
          }

          .tlabel_word {
            font: 400 18px/19px Avenir, Helvetica, Arial, sans-serif;
            color: #0e0f22;
          }
        }
      }

      .table-items {
        @extend %start;
        flex-flow: row wrap;
        width: 100%;
        min-height: 50px;

        .item {
          padding: 5px;

          &.node-item {
            @extend %start;
            width: 100%;
            padding: 0;
            background: #fff;
            border: 1px solid #0e0f22;
            border-bottom: 0;

            &:last-of-type {
              border: 1px solid #0e0f22;
            }

            .item-self {
              width: 200px;
              box-sizing: border-box;
              width: 200px;
              min-height: 49px;

            }

            .item-ul {
              width: calc(100% - 200px);
              min-height: 49px;
              background: #fff;
              border-left: 1px solid #333;
            }
          }

          .item-self {
            width: 180px; //最小宽度
            padding: 15px;
          }

          .item-ul {
            @extend %start;
            flex-flow: row wrap;
            min-width: 180px;
            max-width: calc(210px * 5);
            // margin: 15px 0;
            background: #f1f1f1;

            .item-li {
              width: 180px; //最小宽度
              padding: 15px;
            }
          }
        }
      }
    }
  }
}

.form-user {
  width: 500px;

  .user-table {
    background: #ececec;
    padding: 20px;
    border-radius: 15px;

    >div {
      margin-bottom: 20px;
      @extend %start;
      justify-content: space-between;

      &:last-of-type {
        margin-bottom: 0;
      }

      .dtbtn {
        cursor: pointer;
        border-bottom: 0.2px solid transparent;

        &:hover {
          border-bottom: 0.2px solid #606266;
        }
      }
    }
  }
}
</style>